<script setup>
import { useI18n } from 'vue-i18n';
import { Badge } from 'next/polaris/ui/badge';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  label: {
    type: Object,
    default: null,
  },
  // Kept for callers (e.g. `ContactLabels` tracks the hovered label to avoid flicker on the last
  // item); the kit look shows the remove button unconditionally, so this has no visual effect.
  // eslint-disable-next-line vue/no-unused-properties
  isHovered: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['remove', 'hover']);

const { t } = useI18n();

const handleRemoveLabel = () => {
  emit('remove', props.label);
};

const handleMouseEnter = () => {
  // Notify parent component when this label is hovered (kept for `ContactLabels`' own bookkeeping)
  emit('hover', props.label?.id);
};
</script>

<template>
  <Badge variant="outline" class="gap-1.5 pr-2" @mouseenter="handleMouseEnter">
    <span
      class="size-2 shrink-0 rounded-full"
      :style="{ background: label.color }"
      aria-hidden="true"
    />
    <span class="whitespace-nowrap">{{ label.title }}</span>
    <button
      type="button"
      :aria-label="t('LABEL_MGMT.REMOVE_LABEL', { name: label.title })"
      class="-mr-1 grid size-4 place-items-center rounded-full hover:bg-polaris-accent"
      @click="handleRemoveLabel"
    >
      <Icon icon="i-lucide-x" class="size-3" />
    </button>
  </Badge>
</template>
